import { React, useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Stack, Typography, Box, Button, Alert, Snackbar, TextField, IconButton, Menu } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import Select from "@mui/material/Select";
import TablePagination from "@mui/material/TablePagination";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";
import ConfirmPopup from "./ConfirmPopup";
import Checkbox from "@mui/material/Checkbox";
import BatchScheduleAlert from "./BatchScheduleAlert";
import "./CourseMasterData.css";
import "./THManageNominationCourselist.css";
import {
  getAllNominationDataTH,
  getCount,
  downloadSessionWiseNominatedList,
} from "../app/DeliveryLeadershipSlice";
import useMediaQuery from "@mui/material/useMediaQuery";
import StatusActionPopup from "./StatusActionPopup";

const THManageNominationCourselist = (props) => {
  const [filter, setFilter] = useState(1);
  const [page, setPage] = useState(0);
  const [openConfirmPopup, setOpenConfirmPopup] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [takeAction, setTakeAction] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [takeActionValue, setTakeActionValue] = useState(false);
  const [openActionStatusPopup, setOpenActionStatusPopup] = useState(false);
  const [filters, setFilters] = useState({
  primarySkills: "",
  secondarySkills: "",
  careerLevel: "",
  workLocation: "",
});
const [anchorEl, setAnchorEl] = useState(null);
const [activeColumn, setActiveColumn] = useState(null);

  const dispatch = useDispatch();

  let nominatedCount = useSelector(
    (state) => state.deliveryLeadership.nominatedCount
  );
  let rejectedCount = useSelector(
    (state) => state.deliveryLeadership.rejectedCount
  );
  let failedCount = useSelector(
    (state) => state.deliveryLeadership.failedCount
  );
  let waitlistCount = useSelector(
    (state) => state.deliveryLeadership.waitlistCount
  );
  let scheduledCount = useSelector(
    (state) => state.deliveryLeadership.scheduledCount
  );
  let waitingForBatch = useSelector(
    (state) => state.deliveryLeadership.waitingForBatch
  );
  let discardedCount = useSelector(
    (state) => state.deliveryLeadership.discardedCount
  );
  let isLoading = useSelector((state) => state.isLoaded) || false;
  let nominatedLearnersList = useSelector(
    (state) => state.deliveryLeadership.nominatedUserListTH
  );
  let dataSentSuccefully = useSelector(
    (state) => state.traininghost?.isDataSentSuccess ?? false
  );
  const handleFilterChange = (key, value) => {
  setFilters(prev => ({ ...prev, [key]: value }));
};
const handleOpenFilter = (event, column) => {
  setAnchorEl(event.currentTarget);
  setActiveColumn(column);
};

const handleCloseFilter = () => {
  setAnchorEl(null);
  setActiveColumn(null);
};
const filteredRows =
  nominatedLearnersList.length > 0 &&
  nominatedLearnersList.filter((row) => {
    return (
      (filters.primarySkills === "" ||
        row.primarySkills
          ?.toLowerCase()
          .includes(filters.primarySkills.toLowerCase())) &&

      (filters.secondarySkills === "" ||
        row.secondarySkills?.some((skill) =>
          skill
            ?.toLowerCase()
            .includes(filters.secondarySkills.toLowerCase())
        )) &&

      (filters.careerLevel === "" ||
        row.careerLevel
          ?.toLowerCase()
          .includes(filters.careerLevel.toLowerCase())) &&

      (filters.workLocation === "" ||
        row.workLocation
          ?.toLowerCase()
          .includes(filters.workLocation.toLowerCase()))
    );
  });

  const [selectAll, setSelectAll] = useState(false);
  const [checkBoxid, setCheckBoxid] = useState([]);
  const [openFreezeAlert, setOpenFreezeAlert] = useState(false);
  const currentPageRows = nominatedLearnersList.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const allIds = currentPageRows.map((item) => item.id);
  useEffect(() => {
    dispatch(
      getAllNominationDataTH(props.courseCode, props.sessionCode, filter)
    );
    dispatch(getCount(props.sessionCode));
  }, []);
  useEffect(() => {
    setSelectAll(
      allIds.length > 0 && allIds.every((id) => checkBoxid.includes(id))
    );
  }, [page, rowsPerPage, nominatedLearnersList]);

  const handleCheckboxChange = (sno, id) => {
  setCheckBoxid((prev) => {
    let updated;
    if (prev.includes(id)) {
      updated = prev.filter((x) => x !== id);
    } else {
      updated = [...prev, id];
    }
    setSelectAll(
      allIds.length > 0 && allIds.every((pageId) => updated.includes(pageId))
    );
    setIsChecked(updated.length > 0);
    return updated;
  });
};

  const handleSelectAll = () => {
    if (selectAll) {
      // uncheck all
      setCheckBoxid([]);
      setSelectAll(false);
      setIsChecked(false);
    } else {
      // check all
      setCheckBoxid(allIds); // allIds is the array of all row IDs
      setSelectAll(true);
      setIsChecked(true);
    }
  };
  const ColorButton = styled(Button)(({ theme }) => ({
    fontSize: "14px",
    padding: "5px",
    textTransform: "none",
    color: "white",
    background: "#8A2BE2",
    "&:hover": {
      backgroundColor: "#8A2BE2",
    },
  }));

  const handleChangeFilter = (event) => {
    let filterValue = event.target.value;
    setFilter(event.target.value);
    dispatch(
      getAllNominationDataTH(props.courseCode, props.sessionCode, filterValue)
    );
    setCheckBoxid([]);
    setSelectAll(false);
    setTakeAction(false);
    setIsChecked(false);
    setTakeActionValue(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFinalSubmit = (selectedStatus) => {
    setOpenActionStatusPopup(false);
  };

  const theme = createTheme({
    typography: {
      fontFamily: "Graphik-Regular",
    },
  });

  const GoBackButton = styled(Button)(({ theme }) => ({
    fontSize: "14px",
    textTransform: "none",
    color: "#8A2BE2",
    border: "solid 2px #8A2BE2 ",
  }));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
  return (
    <ThemeProvider theme={theme}>
      <Typography
        sx={{
          fontSize: "1.17em",
          margin: "20px 0px 10px 0px",
          fontWeight: "600",
        }}
      >
        Nomination List for {props.courseName}
      </Typography>
      <Box sx={{ width: "300px" }}>
        <GoBackButton
          onClick={() => {
            props.setIsSelected(false);
            props.setActivePage(false);
            props.setFilteredTrainingList(props.trainingList);
          }}
        >
          Go Back
        </GoBackButton>
      </Box>
      <Stack
        direction={"row"}
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "right",
            marginTop: "10px",
          }}
        >
          <Stack direction={"row"}>
            <Typography
              sx={{
                fontSize: isSmallScreen ? "12px" : "14px",
                color: "#696969	",
              }}
            >
              Number of Nominations Received :
              <span
                style={{
                  fontSize: isSmallScreen ? "14px" : "16px",
                  fontWeight: "600",
                  color: "blue",
                }}
              >
                {nominatedCount}
              </span>
            </Typography>
            <Typography
              sx={{
                fontSize: isSmallScreen ? "12px" : "14px",
                color: "#696969	",
              }}
            >
              Number of Nominations Waiting for Batch :
              <span
                style={{
                  fontSize: isSmallScreen ? "14px" : "16px",
                  fontWeight: "600",
                  color: "blue",
                }}
              >
                {waitingForBatch}
              </span>
            </Typography>
            <Typography
              sx={{
                fontSize: isSmallScreen ? "12px" : "14px",
                color: "#696969	",
              }}
            >
              Number of Nominations Rejected :
              <span
                style={{
                  fontSize: isSmallScreen ? "14px" : "16px",
                  fontWeight: "600",
                  color: "blue",
                }}
              >
                {rejectedCount}
              </span>
            </Typography>
            <Typography
              sx={{
                fontSize: isSmallScreen ? "12px" : "14px",
                color: "#696969	",
              }}
            >
              Number of Nominations Scheduled :
              <span
                style={{
                  fontSize: isSmallScreen ? "14px" : "16px",
                  fontWeight: "600",
                  color: "blue",
                }}
              >
                {scheduledCount}
              </span>
            </Typography>
            <Typography
              sx={{
                fontSize: isSmallScreen ? "12px" : "14px",
                color: "#696969	",
              }}
            >
              Number of Nominations Waitlisted :
              <span
                style={{
                  fontSize: isSmallScreen ? "14px" : "16px",
                  fontWeight: "600",
                  color: "blue",
                }}
              >
                {waitlistCount}
              </span>
            </Typography>
            <Typography
              sx={{
                fontSize: isSmallScreen ? "12px" : "14px",
                color: "#696969	",
              }}
            >
              Number of Nominations Discarded :
              <span
                style={{
                  fontSize: isSmallScreen ? "14px" : "16px",
                  fontWeight: "600",
                  color: "blue",
                }}
              >
                {discardedCount}
              </span>
            </Typography>
            <Typography
              sx={{
                fontSize: isSmallScreen ? "12px" : "14px",
                color: "#696969	",
              }}
            >
              Number of Nominations Failed :
              <span
                style={{
                  fontSize: isSmallScreen ? "14px" : "16px",
                  fontWeight: "600",
                  color: "blue",
                }}
              >
                {failedCount}
              </span>
            </Typography>
          </Stack>
          <Box
            sx={{
              width: isSmallScreen ? "500px" : "290px",
              display: "flex",
              justifyContent: "end",
            }}
          >
            <FormControl sx={{ m: 1, minWidth: 170 }} size="small">
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={filter}
                onChange={handleChangeFilter}
                displayEmpty
                sx={{
                  border: "solid 2px #7500C0",

                  color: "#7500C0",
                  fontWeight: "500",
                  padding: "0px !important",
                }}
              >
                <MenuItem sx={{ color: "#7500C0" }} value={6}>
                  All
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0" }} value={1}>
                  waiting for Batch Allocation
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0" }} value={2}>
                  Scheduled
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0" }} value={3}>
                  Rejected
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0" }} value={4}>
                  Waitlisted
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0" }} value={5}>
                  Discarded
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0" }} value={0}>
                  Failed Nomination
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Stack>
      <Stack direction={"row"} alignItems={"center"}>
        <Stack spacing={1} direction={"row"} sx={{ height: "fit-content" }}>
          { nominatedLearnersList.length != 0 && filter != 0 && <Button
            type="small"
            variant="contained"
            className="tackAction"
            value={takeActionValue}
            onClick={() => {
              setTakeActionValue((prev) => !prev);
              setTakeAction(!takeActionValue);
            }}
          >
            {takeActionValue ?  "No Action" : "Take Action"}
          </Button>}
          {isChecked && takeActionValue &&(
            <Button
              variant="contained"
              onClick={() => {
                setOpenActionStatusPopup(true);
              }}
            >
              Change Status
            </Button>
          )}
          {openActionStatusPopup && (
            <StatusActionPopup
              open={openActionStatusPopup}
              onClose={() => setOpenActionStatusPopup(false)}
              onFinalSubmit={handleFinalSubmit}
              title="Take Action"
              checkBoxid={checkBoxid}
              setCheckBoxid={setCheckBoxid}
              setIsChecked={setIsChecked}
              setTakeAction={setTakeAction}
              sessionCode={props.sessionCode}
              courseCode={props.courseCode}
              filter={filter}
            />
          )}
        </Stack>
      </Stack>

      {nominatedLearnersList.length != 0 ? (
        <Box className="th_upload_fetch_table" sx={{ marginTop: "20px" }}>
          <Paper sx={{ width: "100% !important" }}>
            <TableContainer component={Paper}>
              <Table 
                sx={{ minWidth: 650, tableLayout: "fixed" }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell align="center" sx={{width:50}}>
                      {takeAction && filter != 0 &&(
                        <Checkbox
                          checked={selectAll}
                          onChange={handleSelectAll}
                        />
                      )}{" "}
                    </TableCell>
                    <TableCell align="center"  sx={{width:50}}>Sl No</TableCell>
                    <TableCell align="center" sx={{width:220}}>Enterprise ID</TableCell>
                    {filter == 2 ? (
                      <TableCell align="center" sx={{width:120}}>Scheduled For</TableCell>
                    ) : null}
                    <TableCell align="center" sx={{width:180}}>Primary Skill <span> 
                      <IconButton onClick={(e) => handleOpenFilter(e, "primarySkills")}>
                        <FilterListIcon fontSize="small" 
                        sx={{color: filters.primarySkills ? "blue" : "white"}}/>
                      </IconButton>
                    </span>
                    </TableCell>
                    <TableCell align="center"  sx={{width:180}}>
                    Secondary Skill
                    <span> 
                      <IconButton onClick={(e) => handleOpenFilter(e, "secondarySkills")}>
                        <FilterListIcon fontSize="small" sx={{color: filters.secondarySkills ? "blue" : "white"}}/>
                      </IconButton>
                    </span>
                    </TableCell>
                    <TableCell align="center"  sx={{width:180}}>
                    Career Level
                    <span> 
                      <IconButton onClick={(e) => handleOpenFilter(e, "careerLevel")}>
                        <FilterListIcon fontSize="small" sx={{color: filters.careerLevel ? "blue" : "white"}}/>
                      </IconButton>
                    </span>
                    </TableCell>
                    <TableCell align="center"  sx={{width:180}}>
                    Work Location
                    <span> 
                      <IconButton onClick={(e) => handleOpenFilter(e, "workLocation")}>
                        <FilterListIcon fontSize="small" sx={{color: filters.workLocation ? "blue" : "white"}}/>
                      </IconButton>
                    </span>
                    </TableCell>
                    <TableCell align="center" sx={{width:120}}>Nominated Date</TableCell>
                    <TableCell align="center" sx={{width:120}}>Nominated By</TableCell>
                    <TableCell align="center"  sx={{width:120}}>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredRows.length != 0 &&
                    filteredRows
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((item, index) => (
                        <TableRow key={item.sno}>
                          <TableCell align="center" scope="row">
                            {takeAction && item.status !== 0 && (
                              <Checkbox
                                checked={
                                  Array.isArray(checkBoxid) &&
                                  checkBoxid.includes(item.id)
                                }
                                onChange={() =>
                                  handleCheckboxChange(item.sno, item.id)
                                }
                              />
                            )}
                          </TableCell>
                          <TableCell align="center" scope="row">
                            {item.sno}
                          </TableCell>
                          <TableCell align="center">{item.email}</TableCell>
                          {filter == 2 ? (
                            <TableCell align="center">
                              {item.status == 2 ? item.scheduledDate : ""}
                            </TableCell>
                          ) : null}
                          
                          <TableCell align="center">
                            {item.primarySkills}
                          </TableCell>
                          <TableCell align="center"
                          sx={{
                            width: 250,
                            maxWidth: 200,
                            overflow: "auto",
                            whiteSpace: "nowrap",
                            border: "1px solid lightgray",
                            "&::-webkit-scrollbar": {
                                height: "4px",   // very small horizontal scrollbar height
                              },
                              "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#ce05e0ff",
                                borderRadius: "4px",
                              },
                              "&::-webkit-scrollbar-track": {
                                backgroundColor: "transparent",
                              },
                          }}
                          
                          >
                          {(() => {
                            let v = item.secondarySkills;
                            if (typeof v === "string") v = JSON.parse(v);
                            return Array.isArray(v) ? v.join(", ") : v;
                          })()}
                          </TableCell>
                          <TableCell align="center">
                            {item.careerLevel}
                          </TableCell>
                          <TableCell align="center">
                            {item.workLocation}
                          </TableCell>
                          <TableCell align="center">
                            {item.nominatedDate}
                          </TableCell>
                          <TableCell align="center">
                            {item.nominatedBy}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              minWidth: "250px",
                            }}
                          >
                            {item.status == 2 && filter == 2 ? (
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  padding: "5px",
                                  color: "#8A2BE2",
                                  fontWeight: "600",
                                }}
                              >
                                Scheduled
                              </Typography>
                            ) : item.status == 1 ? (
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  padding: "5px",
                                  color: "#8A2BE2",
                                  fontWeight: "600",
                                }}
                              >
                                Waiting for Batch Allocation
                                <br />
                                {item.actionReason && (
                                  <span
                                    style={{
                                      color: "#32a906",
                                      fontSize: "12px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        color: "red",
                                        marginRight: "5px",
                                      }}
                                    >
                                      *
                                    </span>
                                    {item.actionReason}
                                  </span>
                                )}
                              </Typography>
                            ) : item.status == 0 ? (
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  padding: "5px",
                                  color: "#FF724C",
                                  fontWeight: "500",
                                }}
                              >
                                Failed Nomination
                              </Typography>
                            ) : (
                              <Stack>
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    border: "1px solid #a6a6a6",
                                    borderRadius: "5px",
                                    padding: "3px",
                                    textAlign: "center",
                                    color: item.status == 3 ? "red" : "blue",
                                  }}
                                >
                                  {item.status == 3 || filter == 3
                                    ? "Rejected"
                                    : item.status == 5 || filter == 5
                                    ? "Discarded"
                                    : item.status == 1
                                    ? "Waiting for Batch Allocation"
                                    : "Waitlisted"}
                                </Typography>
                                {item.status == 3 && (
                                  <Typography
                                    sx={{
                                      fontSize: "12px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {item.reason}
                                  </Typography>
                                )}
                                {item.status == 5 && (
                                  <Typography
                                    sx={{
                                      fontSize: "12px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {item.reason}
                                  </Typography>
                                )}
                              </Stack>
                            )}
                          </TableCell>
                          {dataSentSuccefully && (
                            <Snackbar
                              autoHideDuration={5000}
                              anchorOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                              style={{ marginTop: "200px" }}
                            >
                              <Alert severity="success">
                                Status Updated Successfully.!
                              </Alert>
                            </Snackbar>
                          )}
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
               <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseFilter}>
        <MenuItem>
          <TextField
            size="small"
            autoFocus
            placeholder={`Search ${activeColumn}`}
            value={filters[activeColumn] || ""}
            onChange={(e) => handleFilterChange(activeColumn, e.target.value)}
          />
        </MenuItem>
      </Menu>
            </TableContainer>
            <TablePagination
              className="manageNomination_pagination"
              component="div"
              count={
                nominatedLearnersList.length != 0
                  ? nominatedLearnersList.length
                  : null
              }
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{ width: "100% !important" }}
            />
          </Paper>
        </Box>
      ) : (
        <Stack
          justifyContent={"center"}
          alignItems={"center"}
          sx={{ marginTop: "30px", marginBottom: "100px" }}
        >
          <Stack
            spacing={2}
            justifyContent={"center"}
            alignItems={"center"}
            sx={{
              border: "solid 1px #DEDEDE",
              borderRadius: "5px",
              width: "40%",
              padding: "30px",
            }}
          >
            <img
              style={{ width: "100px" }}
              src="/images/POC/norecords.png"
            ></img>
            <Stack direction={"row"} spacing={1}>
              <img
                style={{ width: "20px", height: "20px", marginTop: "3px" }}
                src="/images/POC/norecordsalert.png"
              ></img>
              {isLoading ? (
                <Typography>Loading....</Typography>
              ) : (
                <Typography>No Records Found</Typography>
              )}
            </Stack>
          </Stack>
        </Stack>
      )}
      <Box
        sx={{
          marginBottom: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ColorButton
          onClick={() => {
            dispatch(
              downloadSessionWiseNominatedList(
                props.sessionCode,
                props.courseCode,
                props.startDate,
                filter
              )
            );
          }}
        >
          Download
        </ColorButton>
      </Box>
      <ConfirmPopup
        openConfirmPopup={openConfirmPopup}
        setOpenConfirmPopup={setOpenConfirmPopup}
        clickedID={checkBoxid}
        courseCode={props.courseCode}
        startDate={props.startDate}
      />
      <BatchScheduleAlert
        openFreezeAlert={openFreezeAlert}
        setOpenFreezeAlert={setOpenFreezeAlert}
      ></BatchScheduleAlert>
    </ThemeProvider>
  );
};

export default THManageNominationCourselist;
